import { render, staticRenderFns } from "./PolicyAcknowledgement.vue?vue&type=template&id=5704aaa2&scoped=true"
import script from "./PolicyAcknowledgement.vue?vue&type=script&lang=js"
export * from "./PolicyAcknowledgement.vue?vue&type=script&lang=js"
import style0 from "./PolicyAcknowledgement.vue?vue&type=style&index=0&id=5704aaa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5704aaa2",
  null
  
)

export default component.exports